import { api } from './api';

const makeRoleHeaders = (userRoleUuid) => {
    if (!userRoleUuid) {
        throw new Error('Missing active user role UUID.');
    }

    return {
        'USER-ROLE': userRoleUuid
    };
};

export const listClinicalNotes = async ({
    userRoleUuid,
    subjectRoleUuid,
    clinicianRoleUuid,
    queryTs,
    order,
    paginationToken,
    paginationLimit
} = {}) =>
    api.get('/notes', {
        headers: {
            ...makeRoleHeaders(userRoleUuid),
            ...(subjectRoleUuid ? { 'CVP-QUERY-SUBJECT': subjectRoleUuid } : {}),
            ...(clinicianRoleUuid ? { 'CVP-QUERY-CLINICIAN': clinicianRoleUuid } : {}),
            ...(queryTs ? { 'CVP-QUERY-TS': queryTs } : {}),
            ...(order ? { 'CVP-QUERY-ORDER': order } : {}),
            ...(paginationToken ? { 'PAGINATION-TOKEN': paginationToken } : {}),
            ...(paginationLimit ? { 'PAGINATION-LIMIT': paginationLimit } : {})
        }
    });

export const fetchClinicalNote = async ({ userRoleUuid, noteUuid }) =>
    api.post(
        '/notes/fetch',
        {
            note: noteUuid
        },
        {
            headers: makeRoleHeaders(userRoleUuid)
        }
    );

export const createClinicalNote = async ({ userRoleUuid, payload }) =>
    api.post('/notes', payload, {
        headers: makeRoleHeaders(userRoleUuid)
    });

export const reviseClinicalNote = async ({ userRoleUuid, payload }) =>
    api.patch('/notes', payload, {
        headers: makeRoleHeaders(userRoleUuid)
    });
